import { Component, Input, OnInit } from '@angular/core';
import { NgModel } from '@angular/forms';
import { Control, ControlType } from '../../../models/controls/control';

@Component({
  selector: 'app-field-error',
  templateUrl: './field-error.component.html',
  styleUrls: ['./field-error.component.scss'],
})
export class FieldErrorComponent implements OnInit {
  @Input()
  field?: NgModel;

  @Input()
  control = new Control('', '', ControlType.text);

  constructor() {}

  ngOnInit(): void {}

  hasError(): boolean {
    return (
      (this.field?.invalid && (this.field?.dirty || this.field?.touched)) ||
      false
    );
  }

  getError(error: string): string {
    error = this.getErrorText(error);
    return this.field ? `${this.field.name}.${error}` : '';
  }

  hasInvalidAge(): boolean {
    return this.field && this.field.errors
      ? this.field.errors.minAge === 0 || this.field.errors.minAge
      : false;
  }

  private getErrorText(error: string): string {
    switch (error) {
      case 'required':
      case 'pattern':
      case 'invalidDate':
      case 'mustMatch':
        return error;

      case 'minLength':
      case 'minAge':
        return `${error}.${this.control.min}`;

      default:
        return '';
    }
  }
}
